/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ImageDTO } from "./ImageDTO";
import { ImageDTOFromJSON, ImageDTOFromJSONTyped, ImageDTOToJSON } from "./ImageDTO";
import type { OutCampaignDTO } from "./OutCampaignDTO";
import { OutCampaignDTOFromJSON, OutCampaignDTOFromJSONTyped, OutCampaignDTOToJSON } from "./OutCampaignDTO";
import type { OutFilterDTO } from "./OutFilterDTO";
import { OutFilterDTOFromJSON, OutFilterDTOFromJSONTyped, OutFilterDTOToJSON } from "./OutFilterDTO";
import type { PublicPlatformDTO } from "./PublicPlatformDTO";
import {
  PublicPlatformDTOFromJSON,
  PublicPlatformDTOFromJSONTyped,
  PublicPlatformDTOToJSON
} from "./PublicPlatformDTO";
import type { SeoDTO } from "./SeoDTO";
import { SeoDTOFromJSON, SeoDTOFromJSONTyped, SeoDTOToJSON } from "./SeoDTO";

/**
 *
 * @export
 * @interface OutMerchantDTO
 */
export interface OutMerchantDTO {
  /**
   *
   * @type {number}
   * @memberof OutMerchantDTO
   */
  id: number;
  /**
   *
   * @type {boolean}
   * @memberof OutMerchantDTO
   */
  live?: boolean;
  /**
   *
   * @type {PublicPlatformDTO}
   * @memberof OutMerchantDTO
   */
  platform: PublicPlatformDTO;
  /**
   *
   * @type {string}
   * @memberof OutMerchantDTO
   */
  features?: string;
  /**
   *
   * @type {number}
   * @memberof OutMerchantDTO
   */
  buyInPosition?: number | null;
  /**
   *
   * @type {number}
   * @memberof OutMerchantDTO
   */
  priority?: number | null;
  /**
   *
   * @type {number}
   * @memberof OutMerchantDTO
   */
  eCPC?: number;
  /**
   *
   * @type {number}
   * @memberof OutMerchantDTO
   */
  approvalRate?: number;
  /**
   *
   * @type {number}
   * @memberof OutMerchantDTO
   */
  score?: number;
  /**
   *
   * @type {number}
   * @memberof OutMerchantDTO
   */
  minimumDealScoreModifier?: number | null;
  /**
   *
   * @type {string}
   * @memberof OutMerchantDTO
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof OutMerchantDTO
   */
  trackingUrl?: string;
  /**
   *
   * @type {string}
   * @memberof OutMerchantDTO
   */
  adSenseScript?: string;
  /**
   *
   * @type {boolean}
   * @memberof OutMerchantDTO
   */
  inOverview?: boolean;
  /**
   *
   * @type {ImageDTO}
   * @memberof OutMerchantDTO
   */
  headerImage?: ImageDTO;
  /**
   *
   * @type {ImageDTO}
   * @memberof OutMerchantDTO
   */
  logoImage?: ImageDTO;
  /**
   *
   * @type {SeoDTO}
   * @memberof OutMerchantDTO
   */
  seo?: SeoDTO;
  /**
   *
   * @type {string}
   * @memberof OutMerchantDTO
   */
  lastEdit?: string;
  /**
   *
   * @type {boolean}
   * @memberof OutMerchantDTO
   */
  approved?: boolean;
  /**
   *
   * @type {string}
   * @memberof OutMerchantDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OutMerchantDTO
   */
  slug: string;
  /**
   *
   * @type {Date}
   * @memberof OutMerchantDTO
   */
  updatedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof OutMerchantDTO
   */
  updatedAtByUser?: Date;
  /**
   *
   * @type {Array<OutFilterDTO>}
   * @memberof OutMerchantDTO
   */
  categories?: Array<OutFilterDTO>;
  /**
   *
   * @type {Array<OutCampaignDTO>}
   * @memberof OutMerchantDTO
   */
  campaigns?: Array<OutCampaignDTO>;
}

/**
 * Check if a given object implements the OutMerchantDTO interface.
 */
export function instanceOfOutMerchantDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "slug" in value;

  return isInstance;
}

export function OutMerchantDTOFromJSON(json: any): OutMerchantDTO {
  return OutMerchantDTOFromJSONTyped(json, false);
}

export function OutMerchantDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutMerchantDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    live: !exists(json, "live") ? undefined : json["live"],
    platform: PublicPlatformDTOFromJSON(json["platform"]),
    features: !exists(json, "features") ? undefined : json["features"],
    buyInPosition: !exists(json, "buyInPosition") ? undefined : json["buyInPosition"],
    priority: !exists(json, "priority") ? undefined : json["priority"],
    eCPC: !exists(json, "eCPC") ? undefined : json["eCPC"],
    approvalRate: !exists(json, "approvalRate") ? undefined : json["approvalRate"],
    score: !exists(json, "score") ? undefined : json["score"],
    minimumDealScoreModifier: !exists(json, "minimumDealScoreModifier") ? undefined : json["minimumDealScoreModifier"],
    url: !exists(json, "url") ? undefined : json["url"],
    trackingUrl: !exists(json, "trackingUrl") ? undefined : json["trackingUrl"],
    adSenseScript: !exists(json, "adSenseScript") ? undefined : json["adSenseScript"],
    inOverview: !exists(json, "inOverview") ? undefined : json["inOverview"],
    headerImage: !exists(json, "headerImage") ? undefined : ImageDTOFromJSON(json["headerImage"]),
    logoImage: !exists(json, "logoImage") ? undefined : ImageDTOFromJSON(json["logoImage"]),
    seo: !exists(json, "seo") ? undefined : SeoDTOFromJSON(json["seo"]),
    lastEdit: !exists(json, "lastEdit") ? undefined : json["lastEdit"],
    approved: !exists(json, "approved") ? undefined : json["approved"],
    name: json["name"],
    slug: json["slug"],
    updatedAt: !exists(json, "updatedAt") ? undefined : new Date(json["updatedAt"]),
    updatedAtByUser: !exists(json, "updatedAtByUser") ? undefined : new Date(json["updatedAtByUser"]),
    categories: !exists(json, "categories") ? undefined : (json["categories"] as Array<any>).map(OutFilterDTOFromJSON),
    campaigns: !exists(json, "campaigns") ? undefined : (json["campaigns"] as Array<any>).map(OutCampaignDTOFromJSON)
  };
}

export function OutMerchantDTOToJSON(value?: OutMerchantDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    live: value.live,
    platform: PublicPlatformDTOToJSON(value.platform),
    features: value.features,
    buyInPosition: value.buyInPosition,
    priority: value.priority,
    eCPC: value.eCPC,
    approvalRate: value.approvalRate,
    score: value.score,
    minimumDealScoreModifier: value.minimumDealScoreModifier,
    url: value.url,
    trackingUrl: value.trackingUrl,
    adSenseScript: value.adSenseScript,
    inOverview: value.inOverview,
    headerImage: ImageDTOToJSON(value.headerImage),
    logoImage: ImageDTOToJSON(value.logoImage),
    seo: SeoDTOToJSON(value.seo),
    lastEdit: value.lastEdit,
    approved: value.approved,
    name: value.name,
    slug: value.slug,
    updatedAt: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    updatedAtByUser: value.updatedAtByUser === undefined ? undefined : value.updatedAtByUser.toISOString(),
    categories: value.categories === undefined ? undefined : (value.categories as Array<any>).map(OutFilterDTOToJSON),
    campaigns: value.campaigns === undefined ? undefined : (value.campaigns as Array<any>).map(OutCampaignDTOToJSON)
  };
}
